module.exports = __webpack_public_path__ + "img/nodata.d1518c96.png";